export default "__VITE_ASSET__B_OJM6O2__"